import { render } from "./Pricing4.vue?vue&type=template&id=ae9f54f8"
import script from "./Pricing4.vue?vue&type=script&lang=js"
export * from "./Pricing4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__